import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PublicUser, Role } from '../types';

interface AuthState {
  token: string | null;
  user: PublicUser | null;
  setSession: (token: string, user: PublicUser) => void;
  setUser: (user: PublicUser) => void;
  clear: () => void;
  hasRole: (role: Role) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      setUser: (user) => set({ user }),
      clear: () => set({ token: null, user: null }),
      hasRole: (role) => get().user?.role === role,
    }),
    {
      name: 'von-admin-auth',
      partialize: (s) => ({ token: s.token, user: s.user }),
    },
  ),
);

export function getToken(): string | null {
  return useAuthStore.getState().token;
}
